import type { SVGProps } from "react";
export interface WaterWaveIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WaterWaveIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WaterWaveIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 16.888a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.332 1.129.695 1.868.746l.172.005.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005-.314-.01c-1.305-.085-2.371-.685-3.02-1.151-.701.502-1.886 1.161-3.333 1.161s-2.634-.659-3.334-1.161c-.7.502-1.885 1.161-3.333 1.161s-2.633-.659-3.333-1.161c-.701.502-1.885 1.161-3.333 1.161a1.125 1.125 0 1 1 0-2.25c.923 0 1.755-.513 2.237-.9l.121-.091a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.358 1.233.751 2.04.751.922 0 1.755-.513 2.236-.9l.122-.091a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.358 1.232.751 2.039.751.922 0 1.755-.513 2.237-.9zm0-6.36a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.333 1.129.696 1.868.746l.172.006.115.006a1.125 1.125 0 0 1 0 2.238L22 13.77l-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.503-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.503-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162C4.632 13.111 3.447 13.77 2 13.77a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.515 2.237-.902l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.358 1.233.752 2.04.752.922 0 1.755-.515 2.236-.902l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.358 1.232.752 2.039.752.923 0 1.755-.515 2.237-.902zm0-6.36a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.333 1.129.695 1.868.746L22 5.16l.115.005a1.125 1.125 0 0 1 0 2.239L22 7.41l-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.502-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.502-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162C4.632 6.75 3.448 7.41 2 7.41a1.125 1.125 0 1 1 0-2.25c.923 0 1.755-.514 2.237-.901l.121-.091a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.358 1.233.751 2.04.752.922 0 1.755-.514 2.236-.901l.122-.091a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.358 1.232.751 2.039.752.922 0 1.755-.514 2.237-.901z"
      />
    </svg>
  );
}
